import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "logo-shopperos",
  "use": "logo-shopperos-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 48 48\" id=\"logo-shopperos\"><g fill=\"currentColor\"><path d=\"M22.776 23.421c-.1-6.967-3.092-12.45-5.778-16.01C10.536 10.145 6 16.543 6 24c0 7.456 4.414 13.681 10.735 16.475 2.862-3.701 6.145-9.57 6.041-17.055z\" /><path d=\"M24 6c-.986 0-1.951.08-2.895.23l13.41 16.375c.703.853.703 1.951 0 2.805L21.117 41.77c.94.15 1.901.23 2.884.23 9.94 0 18-8.061 18-18.002C42 14.058 33.94 6 24 6z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol